var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_3818_1940)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.6766 1.32243C12.3894 1.03532 12 0.874023 11.5939 0.874023C11.1878 0.874023 10.7984 1.03532 10.5112 1.32243L9.83631 1.99734L12.0016 4.16268L12.6766 3.48776C12.9637 3.2006 13.125 2.81116 13.125 2.40509C13.125 1.99902 12.9637 1.60958 12.6766 1.32243ZM11.3827 4.78159L9.2174 2.61626L2.1299 9.70376C1.76989 10.0636 1.50525 10.5075 1.3599 10.9953L0.893232 12.5615C0.870701 12.6371 0.869021 12.7174 0.888369 12.7938C0.907716 12.8703 0.947372 12.9401 1.00314 12.9958C1.05891 13.0516 1.12872 13.0913 1.20517 13.1106C1.28163 13.13 1.3619 13.1283 1.43748 13.1058L3.00373 12.6391C3.49153 12.4937 3.93541 12.2291 4.29523 11.8691L11.3827 4.78159Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3818_1940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.089f4b58f5d6ea37f22f20642c2a2ca1.svg";
export { ForwardRef as ReactComponent };